import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/features/marketing/home-page";
import { SEO } from "@/features/marketing/seo";

/** The landing page in another language. No forward to /app here: someone who picks a language came to read it. */
export const Route = createFileRoute("/_marketing/$lang/")({
  head: SEO.home,
  component: HomePage,
});
